import lessRequire from '../../../../config/less-require-resolver';
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Copy from '../../../shared/copy-to-clipboard';

import { Link } from 'react-router';
import { baseUrl } from '../../../../config/route-entry-point';
import { makeStatisticQuery } from '../../functions';
import { getCurrencyIcon } from '../../../../../shared/js/get-currency-icon';
import {getPartnerLandingUrl} from '../../../../../shared/js/externalOfferHelpers';

import map from 'lodash/map';
import httpOnlyDomains from './../../../../../shared/js/httpOnlyDomains';

import '../../../../../shared/modules/streams/components/table/streams-list.less';
lessRequire('modules/streams/components/table/streams-list.less');

const isRocket = process.env.CPA_ENV === 'rocket';

class StreamsList extends React.Component  {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
		const { highlightedRowId } = this.props;
		if (highlightedRowId) {
			this.scrollToRow(highlightedRowId);
		}
	}

	scrollToRow(highlightedRowId) {
		setTimeout(() => {
			const highlightedRow = document.getElementById(`streams_row_${highlightedRowId}`);
			if (highlightedRow) {
				highlightedRow.scrollIntoView({behavior: 'auto', block: 'end'});
			}
		}, 100);
	}

	render() {
		const {
			data,
			onDeleteItem,
			paginationParams,
			toggleLinkBuilder,
			cloneCampaign,
			toggleSplitSessions,
			intl,
			showArchived,
			highlightedRowId
		} = this.props;

		return (
			<div>
				{this.props.showArchived && (
					<div className="alert streams__alert">{intl('Потоки не активны, трафик не принимается')}</div>
				)}
				<table className="dashboard-table streams-table">
					<thead className="dashboard-table__head font-proxima-nova-semibold tets">
						<tr>
							<th><span>id</span></th>
							<th></th>
							<th></th>
							{!isRocket && (
								<th></th>
							)}
							<th><span>{intl('Добавлен')}</span></th>
							<th className="campaign-title"><span>{intl('Название потока')}</span></th>
							<th><span>{intl('Ссылка')}</span></th>
							<th className="actions"><span>{intl('Действия')}</span></th>
						</tr>
					</thead>
					<tbody className="dashboard-table__body">
						{map(data.tableRows, row => {
							return row.is_active
								? activeRow(
									row, toggleLinkBuilder, cloneCampaign, toggleSplitSessions, onDeleteItem, intl,
									highlightedRowId, showArchived
								)
								: notActiveRow(
									row, toggleLinkBuilder, toggleSplitSessions, onDeleteItem, intl, showArchived
								);
						})}
						{
							paginationParams.limit + paginationParams.offset < paginationParams.total_count &&
								<tr className="show-more">
									<th colSpan="16">
										<a href="#" className="icon-show-more font-proxima-nova-regular" onClick={ e => {
											e.preventDefault();
											this.props.fetchCampaignsBatch();
										}}>
											<span> {intl('Показать ещё')} </span>
										</a>
									</th>
								</tr>
						}
					</tbody>
				</table>

			</div>
		);
	}
}

const activeRow = (
	row, toggleLinkBuilder, cloneCampaign, toggleSplitSessions, onDeleteItem, intl, highlightedRowId, showArchived
) => {
	const isHttpOnlyLanding = row.landing_domain &&
		httpOnlyDomains[process.env.CPA_ENV].find(
			domain => row.landing_domain.includes(domain)
		);
	const isHttpOnlyTransit = row.landing_domain && row.transit_domain &&
		httpOnlyDomains[process.env.CPA_ENV].find(
			domain => row.transit_domain.includes(domain)
		);
	const isTransitDomainTypeExternal = row.landing_domain
		&& row.transit_domain
		&& (row.transit_domain_type === 'external');
	const isLandingDomainTypeExternal = row.landing_domain
		&& (row.landing_domain_type === 'external');
	const transitProtocol = (isHttpOnlyTransit || isTransitDomainTypeExternal) ? 'http' : 'https';
	const landingProtocol = (isHttpOnlyLanding || isLandingDomainTypeExternal) ? 'http' : 'https';
	const externalUrl = row.offer_external_integration && getPartnerLandingUrl({
		campaignId: row.id,
		externalIntegration: row.offer_external_integration,
		useRedirect: row.offer_use_redirect,
		offerDomain: row.offer_domain
	}).fullUrl;

	const externalUrlToBasket = row.offer_external_integration && getPartnerLandingUrl({
		campaignId: row.id,
		externalIntegration: row.offer_external_integration,
		useRedirect: row.offer_use_redirect,
		offerDomain: row.offer_domain,
		toBasket: true
	}).fullUrl;
	const rowId = `streams_row_${row.id}`;
	const shouldBlink = highlightedRowId === row.id;

	const ageInMonths = row.last_conversion_age;
	const toBeArchivedIn = Math.ceil(
		moment(row.last_conversion_date || row.created_at)
			.add(9, 'months')
			.diff(moment(), 'days')
	);
	const removalTooltip = intl(
		'Поток будет заархивирован через %d д. (нет конверсий %d мес.)',
		toBeArchivedIn,
		ageInMonths
	);
	const isCloneHidden = row.currency === 'rub';

	return (
		<tr id={rowId} key={row.id} className={shouldBlink ? 'blinking': ''}>
			<td className="streams-table__id">
				<Link to={baseUrl(`campaigns/${row.id}/`)}>{ row.id }</Link>
			</td>
			<td className="streams-table__currency">
				<span className="icon-container"><span>{getCurrencyIcon(row.currency)}</span></span>
			</td>
			<td className="streams-table__language">{row.language}</td>
			{!isRocket && (
				<td>
					{!row.removed_at && !row.is_ignored_autoremove && ageInMonths >= 3 && !showArchived && (
						<div className="icon-danger" title={removalTooltip}></div>
					)}
				</td>
			)}
			<td className="streams-table__datetime">
				{ moment(row.created_at).format('DD.MM.YYYY') }
			</td>
			<td className="streams-table__title font-proxima-nova-bold">
				<Link to={baseUrl(`offers/${row.offer_id}/`)} target="_blank">
					<img
						className="offer-image"
						src={row.offer_image && row.offer_image.length ? row.offer_image : 'http://placehold.it/30x30'}
					/>
				</Link>
				<div className="title-block">
					<Link to={baseUrl(`campaigns/${row.id}/`)}>{ row.title }</Link>
					<Link
						to={baseUrl(`offers/${row.offer_id}/`)}
						target="_blank"
						className="offer-title font-proxima-nova-regular"
					>
						{ row.offer }
					</Link>
					{
						!!row.clone_parent_id &&
						<a
							className="offer-title font-proxima-nova-regular"
						>
							{ intl('Склонировано с') } {row.clone_parent_id}
						</a>
					}
				</div>
			</td>
			<td className="streams-table__link">
				{ row.offer_external_integration && row.redirect_domain && (
					<div className="streams-table__link-copy">
						<Copy copyText={`https://${row.redirect_domain}`}
							tooltipText={intl('Партнерский лендинг')} intl={intl} disabled={row.removed_at}>
							<span>https://{row.redirect_domain}</span>
						</Copy>
					</div>
				)}
				{ row.offer_external_integration && !row.redirect_domain &&
					<div>
						<div className="streams-table__link-copy">
							<Copy copyText={externalUrl}
								tooltipText={intl('Партнерский лендинг')} intl={intl} disabled={row.removed_at}>
								<span>{externalUrl}</span>
							</Copy>
						</div>
						{ row.offer_external_integration === 'online_payments' &&
							<div className="streams-table__link-copy">
								<Copy
									copyText={externalUrlToBasket}
									tooltipText={intl('Корзина товара')}
									intl={intl}
									disabled={row.removed_at}
								>
									<span>{externalUrlToBasket}</span>
								</Copy>
							</div>
						}
					</div>
				}
				{ row.transit_domain && (
					<div className={`streams-table__link-copy ${
						(isHttpOnlyTransit || isTransitDomainTypeExternal) ? 'http-only' : ''
					}`}>
						<Copy
							copyText={`${transitProtocol}://${row.transit_domain}`}
							tooltipText={intl('Транзитка')}
							intl={intl}
							disabled={row.removed_at}>
							<span>{transitProtocol}://{ row.transit_domain }</span>
						</Copy>
					</div>
				)}

				{ row.landing_domain && (
					<div className={`streams-table__link-copy ${
						( isHttpOnlyLanding || isLandingDomainTypeExternal) ? 'http-only' : '' }`
					}>
						<Copy
							copyText={`${landingProtocol}://${row.landing_domain}`}
							tooltipText={intl('Лендинг')}
							intl={intl}
							disabled={row.removed_at}>
							<span>{landingProtocol}://{ row.landing_domain }</span>
						</Copy>
					</div>
				)}

			</td>
			<td className={`streams-table__actions ${row.removed_at ? 'row.removed_at' : ''}`}>
				{ row.has_split_sessions && !row.removed_at && !row.is_archived && (
					<a href="#" className="split-sessions"  title={intl('Сплит-сессии')} onClick={e => {
						e.preventDefault();
						toggleSplitSessions(row.id);
					}}/>
				) }

				{ (row.landing_domain || row.offer_external_integration) && !row.is_archived
					&& <Link to={baseUrl(`campaigns/${row.id}/`)} className="edit" title={intl('Редактировать поток')} />
				}

				{!row.removed_at && !row.is_archived &&
					<a href="#" className="link-builder"  title={intl('Конструктор ссылок')}
						onClick={e => {
							e.preventDefault(); toggleLinkBuilder(row.id);
						}}
					/>
				}

				<Link to={baseUrl(`statistics/general?${statisticQuery(row)}`)}
					target="_blank"
					className="statistics"
					title={intl('Статистика')}
				/>
				{(!row.offer_external_integration && !row.offer_stopped && !isCloneHidden && !row.is_archived) &&
					<a href={`clone/${row.id}`} className="stream-clone" title={intl('Клонировать поток')}
						onClick={e => {
							e.preventDefault();
							cloneCampaign(row.id);
						}}
					/>
				}

				{!row.removed_at && !row.is_archived && (
					<a
						className="delete"
						href="#"
						title={intl(isRocket ? 'Удалить поток' : 'Архивировать поток')}
						onClick={e => {
							e.preventDefault();
							if (window.confirm(intl(isRocket ? 'Вы точно хотите удалить?' : 'Вы точно хотите архивировать?'))) {
								onDeleteItem(row.id);
							}}
						}
					/>
				)}
			</td>
		</tr>
	);
};

const notActiveRow = (row, toggleLinkBuilder, toggleSplitSessions, onDeleteItem, intl, showArchived = false) => {
	const externalUrl = row.offer_external_integration && getPartnerLandingUrl({
		campaignId: row.id,
		externalIntegration: row.offer_external_integration,
		useRedirect: row.offer_use_redirect,
		offerDomain: row.offer_domain
	}).fullUrl;

	const ageInMonths = row.last_conversion_age;
	const toBeArchivedIn = Math.ceil(
		moment(row.last_conversion_date || row.created_at)
			.add(9, 'months')
			.diff(moment(), 'days')
	);
	const removalTooltip = intl(
		'Поток будет заархивирован через %d д. (нет конверсий %d мес.)',
		toBeArchivedIn,
		ageInMonths
	);

	return (
		<tr key={row.id} className="not-active-row">
			<td className="streams-table__id">
				{ row.id }
			</td>
			<td className="streams-table__currency">
				<span className="icon-container"><span>{getCurrencyIcon(row.currency)}</span></span>
			</td>
			<td className="streams-table__language">{row.language}</td>
			{!isRocket && (
				<td>
					{!row.removed_at & !row.is_ignored_autoremove && ageInMonths >= 3 && !showArchived && (
						<div className="icon-danger" title={removalTooltip}></div>
					)}
				</td>
			)}
			<td className="streams-table__datetime">
				{ moment(row.created_at).format('DD.MM.YYYY') }
			</td>
			<td className="streams-table__title">
				<img
					className="offer-image"
					src={row.offer_image && row.offer_image.length ? row.offer_image : 'http://placehold.it/30x30'}
				/>
				<div className="title-block">
					<div>{ row.title }</div>
					<div
						className="offer-title font-proxima-nova-regular"
					>
						{ row.offer }
					</div>
					{
						!!row.clone_parent_id &&
						<div
							className="offer-title font-proxima-nova-regular"
						>
							{ intl('Склонировано с') } {row.clone_parent_id}
						</div>
					}
				</div>
			</td>
			<td className="streams-table__link">
				{ row.offer_external_integration && row.redirect_domain && (
					<div className="streams-table__link-copy">
						<span>https://{row.redirect_domain}</span>
					</div>
				)}
				{ row.offer_external_integration && !row.redirect_domain && (
					<div className="streams-table__link-copy">
						<span>{externalUrl}</span>
					</div>
				)}
				{ row.transit_domain && (
					<div className="streams-table__link-copy">
						<span>http://{ row.transit_domain }</span>
					</div>
				)}

				{ row.landing_domain && (
					<div className="streams-table__link-copy">
						<span>http://{ row.landing_domain }</span>
					</div>
				)}
			</td>
			<td className="streams-table__actions">
				<Link to={baseUrl(`statistics/general?${statisticQuery(row)}`)}
					target="_blank"
					className="statistics"
					title={intl('Статистика')}
				/>
				{!row.removed_at && !showArchived && (
					<a
						className="delete"
						href="#"
						title={intl(isRocket ? 'Удалить поток' : 'Архивировать поток')}
						onClick={e => {
							e.preventDefault();
							if (window.confirm(intl(isRocket ? 'Вы точно хотите удалить?' : 'Вы точно хотите архивировать?'))) {
								onDeleteItem(row.id);
							}}
						}
					/>
				)}
			</td>

		</tr>
	);
};

const statisticQuery = row => {
	return makeStatisticQuery({
		currency: row.currency,
		filters:{
			campaigns: [{
				id: row.id,
				text: row.title
			}]
		}
	});
};

StreamsList.propTypes = {
	data: PropTypes.object,
	onDeleteItem: PropTypes.func,
	toggleLinkBuilder: PropTypes.func,
	cloneCampaign: PropTypes.func,
	toggleSplitSessions: PropTypes.func,
	intl: PropTypes.func,
	highlightedRowsId: PropTypes.string
};

export default StreamsList;



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/streams/components/table/streams-list.js